import { IBasket } from 'libs/shared/src/models/baskets/basket';
import { PictureDisplayMode } from '../../../basic';
import { IUiButtonSettings } from '../../../configs/ui-elements';
import { IWatchlistItem } from '../../../watchlist/watchlist-item';
import { GsStructComponent, GsStructPageItems } from '../component';
import { IDialog, IMethod, IPaginated } from './../basic';

export interface IWatchlistHeader {
  code?: {
    /** The ID of the specific basket  */
    BasketID: number;
  };
}

export interface IWatchlistRender {
  items: IPaginated<IWatchlistItem>;
  methods: IWatchlistMethods;
  basket: IBasket;
}

/** Answer of the watchlist actions (delete, deleteAll, addToCheckout, addAllToCheckout). */
export interface IWatchlistActionResponse {
  /** Set when the backend rejected the action. */
  error?: boolean;
  /** Present when the basket changed, so the shopping cart needs a refresh. */
  basket?: IBasket;
}

/** Answer of the tile watchlist toggle (toggleWatchList) — CS4-1278. */
export interface IToggleWatchlistResponse {
  /** Set when the backend rejected the action. */
  error?: boolean;
  /** The article the toggle acted on. */
  articleID?: number;
  /** The variant the toggle acted on, only set when a variant tile was clicked. */
  articleKeyID?: number;
  /** The new watchlist state. Missing means the state is unknown and must stay untouched. */
  inWatchlist?: boolean;
  /** Present when the basket changed, so the header counts need a refresh. */
  basket?: IBasket;
}

/**
 * Answer of the tile watchlist state (getWatchlistState) - CS4-1278.
 *
 * Deliberately its own call instead of a field on the search hit: the rendered component JSON
 * goes into the SHARED page cache, whose key only separates visitors on a B2B login.
 */
export interface IWatchlistStateResponse {
  /** Set when the backend rejected the call. */
  error?: boolean;
  /** Articles that lie on the watchlist, with any of their variants. */
  articleIDs?: number[];
  /** Variants that lie on the watchlist, for variant tiles. */
  articleKeyIDs?: number[];
}

/** Answer of the watchlist share actions (createLink, createSendMail, sendMail). */
export interface IWatchlistShareResponse {
  /** The share link, answered by `createLink`. */
  link?: string;
  /** The share-by-email form, answered by `createSendMail`. */
  dialog?: IDialog;
  /** Whether the mail was sent, answered by `sendMail`. */
  result?: boolean;
}

export enum ItemType {
  Article = 0,
  Custom = 1,
  Giveaway = 2,
  ShippingCosts = 3,
  Text = 4
}

export interface GsStructWatchlistComponent extends GsStructComponent<IWatchlistRender>, GsStructPageItems {
  componentType: 'Watchlist';
  showPicture: boolean;
  showOrderButton: boolean;
  showShareButton: boolean;
  showAddAllToCartButton: boolean;
  newForDays?: number;
  /** How the item picture fills its container (Cut = cover, Full = contain, Auto = the photo's own StretchMode). */
  pictureDisplayMode?: PictureDisplayMode;
  /** Button styling overrides for this component */
  buttons?: IUiButtonSettings;
}

export interface IWatchlistMethods {
  delete: IMethod;
  deleteAll: IMethod;
  addToCheckout: IMethod;
  addAllToCheckout: IMethod;
  sendMail: IMethod;
  createSendMail: IMethod;
  createLink: IMethod;
  update: IMethod;
}
